// extracted by mini-css-extract-plugin
module.exports = {"box":"_4KbZv0hYVjrJm9k11UFkv","pagination":"_2q8U6RNufvnuywF_sNNrvl","disabled":"_3qzz8SX_Hm_kaVgCzTm5tu","active":"_2K2-goyDLFtCnRHtoxh1CW","more":"_2AwQf5Ueq5705npD4id7IF"};